import React from 'react';
import { motion } from 'framer-motion';
import { TECH_FEATURES } from '../../data/techFeatures';
import { SmartAppIcon } from './TechIcons';
import { Lock, RefreshCw, BarChart3, MapPin, Lightbulb, Gauge, Home, Smartphone } from 'lucide-react';

export function NewApp() {
  const data = TECH_FEATURES.find(f => f.id === 'app');
  if (!data) return null;

  const features = [
    { icon: Lock, label: 'Bloqueo Remoto' },
    { icon: MapPin, label: 'Geolocalización' },
    { icon: BarChart3, label: 'Estadísticas' },
    { icon: Gauge, label: 'Velocidad' },
    { icon: Lightbulb, label: 'Iluminación' },
    { icon: Home, label: 'Domótica' },
    { icon: RefreshCw, label: 'Update OTA' },
    { icon: Smartphone, label: 'Android/iOS' },
  ];

  return (
    <section id="app" className="py-24 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 text-sm font-medium mb-4">
            Sistema Tuya Smart
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {data.title}
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            {data.description}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Visual Side */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex justify-center"
          >
            <div className="relative">
              {/* Glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-full blur-3xl scale-150" />

              {/* Icon */}
              <SmartAppIcon className="relative w-64 h-64 text-gray-800" />

              {/* Connection Lines */}
              <motion.div
                className="absolute -left-8 top-1/2 w-16 h-0.5 bg-gradient-to-l from-gray-400 to-transparent"
                animate={{ opacity: [0.3, 1, 0.3] }}
                transition={{ duration: 2, repeat: Infinity }}
              />
              <motion.div
                className="absolute -right-8 top-1/2 w-16 h-0.5 bg-gradient-to-r from-gray-400 to-transparent"
                animate={{ opacity: [0.3, 1, 0.3] }}
                transition={{ duration: 2, repeat: Infinity, delay: 1 }}
              />
            </div>
          </motion.div>

          {/* Grid Features */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {features.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col items-center text-center hover:shadow-md transition-shadow"
              >
                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center text-white mb-3">
                  <item.icon className="w-5 h-5" />
                </div>
                <span className="text-sm font-medium text-gray-700">{item.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
